"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ButtonColors = require("./ButtonColors");
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 *
 * @param color ['primary', 'success', 'danger', 'secondary', 'light', 'destructive', 'outline']
 * @param disabled Boolean
 * @param variant ['contained', 'outlined', 'ghost', 'linked']
 * @param state ['default', 'hover', 'pressed', 'active', 'focus']
 * @param iconOnly boolean
 * @returns {*|string}
 */
var getBackgroundColor = function getBackgroundColor(_ref) {
  var color = _ref.color,
    disabled = _ref.disabled,
    variant = _ref.variant,
    iconOnly = _ref.iconOnly;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var colors = iconOnly ? _ButtonColors.iconColors : _ButtonColors.buttonColors;
  if (variant === 'link') {
    return 'transparent';
  }
  if (variant === 'outlined' && state === 'default') {
    return colors[color]['outlined'].background;
  }
  if (variant === 'ghost' && state === 'default') {
    return colors[color]['ghost'].background;
  }
  return colors[color][state].background;
};

/**
 *
 * @param color ['primary', 'success', 'danger', 'secondary', 'light', 'destructive', 'outline']
 * @param disabled Boolean
 * @param variant ['contained', 'outlined', 'ghost', 'linked']
 * @param state ['default', 'hover', 'pressed', 'active', 'focus']
 * @param iconOnly boolean
 * @returns {*|string}
 */
var getTextColor = function getTextColor(_ref2) {
  var color = _ref2.color,
    disabled = _ref2.disabled,
    variant = _ref2.variant,
    iconOnly = _ref2.iconOnly;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var colors = iconOnly ? _ButtonColors.iconColors : _ButtonColors.buttonColors;
  if (variant === 'link') {
    return colors[color][state].background;
  }
  if (variant === 'outlined' && state === 'default') {
    return colors[color]['outlined'].text;
  }
  if (variant === 'ghost' && state === 'default') {
    return colors[color]['ghost'].text;
  }
  return colors[color][state].text;
};
/**
 *
 * @param color ['primary', 'success', 'danger', 'secondary', 'light', 'destructive', 'outline']
 * @param disabled Boolean
 * @param variant ['contained', 'outlined', 'ghost', 'linked']
 * @param state ['default', 'hover', 'pressed', 'active', 'focus']
 * @param iconOnly boolean
 * @returns {*|string}
 */
var getBorderColor = function getBorderColor(_ref3, state) {
  var color = _ref3.color,
    disabled = _ref3.disabled,
    variant = _ref3.variant,
    iconOnly = _ref3.iconOnly;
  var colors = iconOnly ? _ButtonColors.iconColors : _ButtonColors.buttonColors;
  if (variant === 'outlined' && state === 'default') {
    return colors[color]['outlined'].border;
  }
  if (variant === 'ghost' && state === 'default') {
    return colors[color]['ghost'].border;
  }
  return colors[color][state].border;
};
var getBoxShadow = function getBoxShadow(_ref4) {
  var color = _ref4.color,
    disabled = _ref4.disabled,
    variant = _ref4.variant,
    iconOnly = _ref4.iconOnly;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  if (variant === 'link') {
    return 'none';
  }
  var shadowColor = getBorderColor({
    color: color,
    disabled: disabled,
    variant: variant,
    iconOnly: iconOnly
  }, state);
  var shadowWidth = state == 'focus' ? '2px' : '1px';
  var boxShadowStyle = "0 0 0 ".concat(shadowWidth, " ").concat(shadowColor, " inset");
  return boxShadowStyle;
};
var paddingMap = {
  iconOnly: {
    small: '6px',
    medium: '8px',
    large: '10px'
  },
  small: '4px 8px',
  medium: '8px 24px',
  large: '10px 24px'
};
var getPadding = function getPadding(_ref5) {
  var iconOnly = _ref5.iconOnly,
    size = _ref5.size;
  if (iconOnly) {
    return paddingMap['iconOnly'][size];
  }
  return paddingMap[size];
};
var getBorderRadius = function getBorderRadius(_ref6) {
  var size = _ref6.size;
  return size === 'small' ? '6px' : '10px';
};
var getGapSize = function getGapSize(_ref7) {
  var size = _ref7.size;
  return size === 'small' ? '4px' : '8px';
};
var getLineHeight = function getLineHeight(_ref8) {
  var size = _ref8.size;
  return size === 'small' ? '19.5px' : '24px';
};
var getTextFontSize = function getTextFontSize(_ref9) {
  var size = _ref9.size;
  return size === 'small' ? '13px' : '16px';
};
var getIconLineHeight = function getIconLineHeight(_ref10) {
  var iconOnly = _ref10.iconOnly,
    size = _ref10.size;
  if (iconOnly && size === 'medium') {
    return '16px';
  }
  return '12px';
};
var getIconFontSize = function getIconFontSize(_ref11) {
  var iconOnly = _ref11.iconOnly,
    size = _ref11.size;
  if (iconOnly && size === 'medium') {
    return '16px';
  }
  return '12px';
};
var getWidth = function getWidth(_ref12) {
  var iconOnly = _ref12.iconOnly,
    size = _ref12.size;
  if (iconOnly) {
    return size === 'small' ? '28px' : size === 'medium' ? '40px' : '44px';
  }
  return 'auto';
};
var StyledButton = exports.StyledButton = _styledComponents["default"].button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  gap: ", ";\n  border-radius: ", ";\n  line-height: ", ";\n  font-size: ", "; //\n  padding: ", "; //\n  color: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  pointer-events: ", ";\n  opacity: ", ";\n  width: ", ";\n  height: ", ";\n\n  svg {\n    line-height: ", ";\n    font-size: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n    box-shadow: ", ";\n    background-color: ", ";\n  }\n  &:focus {\n    color: ", ";\n    box-shadow: ", ";\n    background-color: ", ";\n    outline: none !important;\n    ", "\n  }\n\n  &:not(:disabled):not(.disabled):active {\n    color: ", ";\n    box-shadow: ", ";\n    background-color: ", ";\n  }\n"])), function (_ref13) {
  var size = _ref13.size;
  return getGapSize({
    size: size
  });
}, function (_ref14) {
  var size = _ref14.size;
  return getBorderRadius({
    size: size
  });
}, function (_ref15) {
  var size = _ref15.size;
  return getLineHeight({
    size: size
  });
}, function (_ref16) {
  var size = _ref16.size;
  return getTextFontSize({
    size: size
  });
}, function (_ref17) {
  var iconOnly = _ref17.iconOnly,
    size = _ref17.size;
  return getPadding({
    iconOnly: iconOnly,
    size: size
  });
}, function (props) {
  return getTextColor(props);
}, function (props) {
  return getBoxShadow(props);
}, function (props) {
  return getBackgroundColor(props);
}, function (_ref18) {
  var disabled = _ref18.disabled;
  return disabled ? 'none' : 'auto';
}, function (_ref19) {
  var disabled = _ref19.disabled;
  return !disabled ? 100 : '40%';
}, function (_ref20) {
  var iconOnly = _ref20.iconOnly,
    size = _ref20.size;
  return getWidth({
    iconOnly: iconOnly,
    size: size
  });
}, function (_ref21) {
  var iconOnly = _ref21.iconOnly,
    size = _ref21.size;
  return getWidth({
    iconOnly: iconOnly,
    size: size
  });
}, function (_ref22) {
  var iconOnly = _ref22.iconOnly,
    size = _ref22.size;
  return getIconLineHeight({
    iconOnly: iconOnly,
    size: size
  });
}, function (_ref23) {
  var iconOnly = _ref23.iconOnly,
    size = _ref23.size;
  return getIconFontSize({
    iconOnly: iconOnly,
    size: size
  });
}, function (props) {
  return getTextColor(props, 'hover');
}, function (props) {
  return getBoxShadow(props, 'hover');
}, function (props) {
  return getBackgroundColor(props, 'hover');
}, function (props) {
  return getTextColor(props, 'focus');
}, function (props) {
  return getBoxShadow(props, 'focus');
}, function (props) {
  return getBackgroundColor(props, 'focus');
}, function (_ref24) {
  var variant = _ref24.variant;
  return variant === 'link' && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        outline: none;\n        text-decoration: underline;\n      "])));
}, function (props) {
  return getTextColor(props, 'active');
}, function (props) {
  return getBoxShadow(props, 'active');
}, function (props) {
  return getBackgroundColor(props, 'active');
});